import {
  ROUTE_FEATURE_FLAGS,
  ROUTE_REDIRECTS,
} from '@/constants/featureFlagRoutes'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { Navigate } from 'react-router-dom'
import LoadingCard from './LoadingCard'

export type FlagRouteProps = {
  children: React.ReactNode
  path?: string
  isRedirect?: boolean
}

export default function FlagRoute({
  children,
  path,
  isRedirect,
}: FlagRouteProps) {
  const flags = useFlags()
  const flagName = path
    ? ROUTE_FEATURE_FLAGS[path as keyof typeof ROUTE_FEATURE_FLAGS]
    : undefined

  // Check if LaunchDarkly is still loading flags
  const isLoading = flags === undefined || Object.keys(flags).length === 0

  // Show loading state while flags are loading to prevent premature redirects
  if (isLoading) {
    return <LoadingCard />
  }

  const isFlagEnabled = flagName === undefined ? true : flags[flagName]

  if (!isFlagEnabled) {
    return isRedirect ? <Navigate to={ROUTE_REDIRECTS.default} /> : null
  }

  return children
}
